import { Typography } from "@mui/material";

export default function PostMuiThemePreload(props) {
  return (
    <div className="mui-theme-preload d-none">
      <Typography owner="client" variant="h1" singles="true">
        Title
      </Typography>
      <Typography owner="client" variant="h2" singles="true">
        Subtitle
      </Typography>
      <Typography
        owner="client"
        variant="body2"
        singles="true"
        weight="light"
        lh="wide"
      >
        Body
      </Typography>
      <Typography
        owner="client"
        variant="body2"
        singles="true"
        weight="light"
        lh="wide"
      >
        List
      </Typography>
      <Typography
        owner="client"
        variant="overline"
        singles="true"
        weight="light"
        notransform={true}
      >
        Table
      </Typography>
    </div>
  );
}
